import React from 'react';

import PartnerLogos from '@hpstellar/core/PartnerLogos';

import withWindowResize from '../../ui/components/window-resize';

import './footer-logo.less';

const FooterLogo = ({ logos, width, breakpoint }) => {
    if (width >= breakpoint) return null;
    return (
        <div className="footerLogo">
            <PartnerLogos {...(logos || {})} />
        </div>
    );
};

export default withWindowResize(FooterLogo);
